import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import List from "../Components/Purchase Order/List";
import View from "../Components/Purchase Order/View";
import Add from "../Components/Purchase Order/Add";
import Layout from "../Layout";
import FixedAssets from "../Components/Purchase Order/FixedAssets";

function PurchaseOrder() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;
      case "fixed":
        return (
          <FixedAssets comp={comp} rowData={rowData} onChange={handleChange} />
        );
      default:
        return (
          <Add
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            currentOrder={currentOrder}
          />
        );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Purchase Order</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default PurchaseOrder;
